// All mock data for the frontend portfolio.
// Source: PDF cover & project pages (Shreya Chandrasekar - 2025-26 portfolio)

export const profile = {
  name: 'Shreya Chandrasekar',
  title: 'Interdisciplinary Designer',
  program: 'B.Des — Global Design Program',
  university: 'United Institute of Design (UID), Karnavati University',
  year: '2025 — 26',
  email: 'shreyacdeku2006@gmail.com',
  phone: '+91 63807 30648',
  about:
    "Hi! I'm currently in my 2nd year of the Bachelor of Design program. My work ranges from illustration and graphic design to storyboarding, animation, branding and merch design.",
  about2:
    'I consider myself a Renaissance student — in pursuit to learn, understand and improve in every sector of design that inspires me. Every project is a chance to see a part of the world I would have never known existed, had I not taken a chance to learn.',
  bigQuote:
    'Curiosity drawn into form. Stories carried by colour, paper and pixels.',
  location: 'Gandhinagar, India',
  socials: [
    { label: 'Instagram', url: '#' },
    { label: 'Behance', url: '#' },
    { label: 'LinkedIn', url: '#' },
  ],
};

export const softwares = [
  { name: 'Adobe Illustrator', short: 'Ai', level: 92 },
  { name: 'Adobe Photoshop', short: 'Ps', level: 88 },
  { name: 'Adobe InDesign', short: 'Id', level: 85 },
  { name: 'Procreate', short: 'Pr', level: 95 },
  { name: 'Canva', short: 'Cv', level: 80 },
];

export const disciplines = [
  'Illustration', 'Graphic Design', 'Branding', 'Packaging', 'Animation',
  'Storyboarding', 'Merch Design', 'Editorial', 'Research',
];

export const projects = [
  {
    id: 'bugs-alive',
    index: '01',
    title: 'Bugs Alive',
    year: '2025',
    tags: ['Illustration', 'Graphic Design', 'Interactive Media'],
    summary:
      'An accordion book celebrating insects, arachnids and invertebrates native to Australia — built with paper engineering for a tactile, exhibition-style read.',
    description:
      "Inspired by the Bugs Alive! exhibition at the Melbourne Museum, this interactive accordion book reframes overlooked creatures as vital, intricate companions of nature. Each page reveals a different bug through flaps, pull tabs and movable parts that mirror the exploratory spirit of the exhibition.",
    role: ['Concept', 'Illustration', 'Paper Engineering', 'Layout'],
    tools: ['Illustrator', 'InDesign'],
    cover: '/portfolio/page-2.jpg',
    sheet: '/portfolio/page-2.jpg',
  },
  {
    id: 'navarasa',
    index: '02',
    title: 'Navarasa',
    year: '2025',
    tags: ['Research', 'Branding', 'Packaging Design'],
    summary:
      'A nine-night advent calendar for Navratri — translating the nine rasas of Indian aesthetics into a slow, sensorial gifting experience.',
    description:
      "Navarasa is a nine-day Navratri advent calendar inspired by the painting 'Lalita Ragini'. Each compartment opens onto one of nine emotions, mirroring the festival's invitation to feel — slowly, fully, and in turn. Nine nights. Nine emotions. One gift.",
    role: ['Research', 'Brand Identity', 'Packaging', 'Pattern Design'],
    tools: ['Illustrator', 'Photoshop'],
    cover: '/portfolio/page-3.jpg',
    sheet: '/portfolio/page-3.jpg',
  },
  {
    id: 'poster-design',
    index: '03',
    title: 'Poster Design',
    year: '2025',
    tags: ['Poster', 'Editorial', 'Visual Identity'],
    summary:
      "Twin posters that pair St. Peter's Cathedral and SEA LIFE Melbourne Aquarium — a meditation on calm, light and immersion across two very different sanctuaries.",
    description:
      "This series finds an unexpected common ground between Melbourne's spiritual landmark and its underwater world: stillness, scale and a quiet sense of awe. Each pair shares a colour story while staying true to its own architecture of feeling.",
    role: ['Concept', 'Illustration', 'Typography'],
    tools: ['Illustrator', 'Photoshop'],
    cover: '/portfolio/page-4.jpg',
    sheet: '/portfolio/page-4.jpg',
  },
  {
    id: 'sticky-dog',
    index: '04',
    title: 'Sticky Dog',
    year: '2025',
    tags: ['Logo Design', 'Branding', 'Promotion'],
    summary:
      'A sticker label and stall identity for a small entrepreneurial venture — a long-snouted borzoi made of glue-bottle nostalgia and student humour.',
    description:
      "Sticky Dog is the logo and visual identity for a small student-run sticker business. The mark borrows the playful semiotics of classic glue brands and reimagines them as a borzoi — sticky, loyal and a little unhinged. Launched as a college market stall.",
    role: ['Logo Design', 'Identity System', 'Stall Setup'],
    tools: ['Illustrator', 'Photoshop'],
    cover: '/portfolio/page-5.jpg',
    sheet: '/portfolio/page-5.jpg',
  },
  {
    id: 'waltz-of-mischief',
    index: '05',
    title: 'The Waltz of Mischief',
    year: '2025',
    tags: ['Animation', 'Storyboarding', '2D'],
    summary:
      "A 30-second animated short born from a one-week challenge — mice in love with fruit, a clueless baker, and the moment fantasy meets reality.",
    description:
      "A whimsical 2D short made in a week. Inspired by Ratatouille and the lightness of ballet, the film follows a troupe of mice who fall in love with fruits, only for an oblivious baker to break the spell. A study in pacing, timing and tiny heartbreaks.",
    role: ['Concept', 'Storyboard', 'Character Design', 'Animation'],
    tools: ['Procreate', 'Photoshop'],
    cover: '/portfolio/page-6.jpg',
    sheet: '/portfolio/page-6.jpg',
  },
  {
    id: 'celestial-neon',
    index: '06',
    title: 'Celestial Neon',
    year: '2026',
    tags: ['Merch Design', 'Branding', 'Fashion'],
    summary:
      "A maximalist merch line for Melbourne's RISING festival — celestial motifs, neon palettes and silhouettes that move with the crowd.",
    description:
      "A deep dive into RISING — its art, its installations, its after-dark electricity — translated into a six-look apparel capsule. The line reimagines the festival's installations as wearable patterns, with bold gradients and stagewear-ready silhouettes.",
    role: ['Concept', 'Pattern Design', 'Apparel Layout', 'Promo Art'],
    tools: ['Illustrator', 'Canva'],
    cover: '/portfolio/page-7.jpg',
    sheet: '/portfolio/page-7.jpg',
  },
  {
    id: 'pattachitra',
    index: '07',
    title: 'Pattachitra',
    year: '2025',
    tags: ['Cultural Research', 'Illustration', 'Tribute'],
    summary:
      "A tribute to Odisha's living tradition — studying Pattachitra not as artefact but as a model of resilience between change and authenticity.",
    description:
      "Pattachitra is a personal study of the Odia scroll-painting tradition tied to Lord Jagannath. The project looks at how a centuries-old art form has adapted through Mughal and colonial eras without losing itself — and what that means for designers learning to balance tradition with their own voice.",
    role: ['Research', 'Illustration Study', 'Editorial'],
    tools: ['Procreate', 'Acrylic on Cotton Rag'],
    cover: '/portfolio/page-8.jpg',
    sheet: '/portfolio/page-8.jpg',
  },
];

export const testimonials = [
  {
    quote:
      "Shreya brings an unusual gentleness to her process — she listens to a project the way an illustrator listens to a story. Her work always carries that patience.",
    author: 'Studio Mentor',
    role: 'Visiting Faculty, UID',
  },
  {
    quote:
      "Bright, curious, and unafraid to mix mediums. Whether it's pattern, paper or motion, Shreya keeps asking the next interesting question.",
    author: 'Design Peer',
    role: 'B.Des, Global Design Program',
  },
  {
    quote:
      "Her packaging studies have a maturity beyond her year — concept, craft and storytelling held together with real care.",
    author: 'Industry Reviewer',
    role: 'Brand & Packaging',
  },
];

export const references = [
  {
    name: 'Sweta Dalal',
    title: 'Head of the Global Design Department',
    org: 'Karnavati University',
    contact: 'swetadalal@karnavatiuniversity.edu.in',
  },
  {
    name: 'Lathamani Rajkumar',
    title: 'Director & Curator',
    org: 'Shrishti Arts Academy',
    contact: 'info@lathamanirajkumarshrishti.in',
    phone: '+91 98844 15279',
  },
];
